import type {
  RestoreBlocksHiddenFromPreview,
  SummaryBlockCreate,
  SummaryBlockDelete,
  SummaryBlockHideFromPreview,
  SummaryBlockReorder,
  SummaryBlockShowInPreview,
  SummaryBlockUpdate,
  SummarySectionDelete,
  SummarySectionReorder,
} from '@domain/schemas/endorsement-summary.schema';
import { getCurrentDocumentApiUrl } from '@helpers/getCurrentDocumentApiUrl';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import axios from 'axios';

import { queryClient } from '../utils/queryClient';

type Response = { message: 'success'; id?: string };

type PatchEndorsementSummaryData =
  | SummaryBlockCreate
  | SummaryBlockDelete
  | SummaryBlockHideFromPreview
  | SummaryBlockShowInPreview
  | SummaryBlockReorder
  | SummaryBlockUpdate
  | RestoreBlocksHiddenFromPreview
  | SummarySectionDelete
  | SummarySectionReorder;

type PatchEndorsementSummary = (data: PatchEndorsementSummaryData) => Promise<Response>;

export const patchEndorsementSummary: PatchEndorsementSummary = async (data) => {
  const url = getCurrentDocumentApiUrl(location.pathname);
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url,
    data,
  });

  const response = await axios(networkPayload);
  await queryClient.invalidateQueries({ queryKey: ['submissions'] });
  return response.data;
};
